module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic12.3d591ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic12.png
// module id = 491
// module chunks = 1